import { useDchampsRanks } from '@repository/dchamps/useDchamps';
import { DevChampsFinalsUserDto } from '@domain/rs/dchamps/DevChampsFinalsUserListRs';
import { DchampsEventEnum } from '@domain/constant/dchamps/eventType';
import classnames from 'classnames/bind';
import styles from './rankChart.module.scss';

const cx = classnames.bind(styles);

interface CardItemProps {
  data: DevChampsFinalsUserDto;
}
const CardItem = ({ data }: CardItemProps) => {
  return (
    <a role="button" className={cx('cardWrap')}>
      {data.userId}
    </a>
  );
};

const RankChart = () => {
  const { data } = useDchampsRanks(DchampsEventEnum.DEV_CHAMPS_2023_09);

  if (!data) return null;

  const cardListEl = data?.users?.map((item, index) => {
    return <CardItem key={index} data={item} />;
  });

  return (
    <div>
      <div className={cx('titleArea')}>
        <div>
          <strong className={cx('title')}>축하드립니다. 9월 디챔스 본선 대상자가 선정되었습니다.</strong>
          <div className={cx('updateDate')}>
            예상보다 많은 참가자로 인해 조기 선정되었습니다. 본선은 10월 1일 오후 3시에 본 페이지에서 진행됩니다.
          </div>
        </div>
      </div>

      {/* 랭킹 차트 영역 */}
      <div className={cx('rankChartArea')}>{cardListEl}</div>
    </div>
  );
};

export default RankChart;
